<bn-loading-overlay></bn-loading-overlay>
<h5>Janelas de Atualização de Informações</h5>
<div class="container">
   <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()" >
        <div class="row">
            <div class="col">
                <h3>Filtros de pesquisa</h3>
            </div>
            
            <div class="col-auto" *ngIf="podeIncluirNovaJanela">
                <button class="btn btn-primary no-margin" type="button" [routerLink]="['/janelas-atualizacao-info']" 
                  ngbTooltip="Tela para cadastro de Janela de Atualização de Informações."><i class="fa fa-file-signature">
                  </i> Cadastrar nova Janela de Atualização de Informações
                </button>
            </div> 

            <div class="col-auto">
                <button type="button" class="btn btn-light" (click)="limpaFormulario()">Limpar</button>
            </div>      

            <div class="col-auto">
                <button #focusableSubmit type="button" 
                        class="btn btn-success no-margin" 
                        (keydown.enter)="buscar()" 
                        (click)="buscar()">Pesquisar
                </button>
            </div>

        </div>

        <div class="row"> 
            <div class="bn-form-group col-md-4">
                <label class="form-label">Data de abertura:</label>
                <bn-datepicker 
                    name="dataAbertura" 
                    idInput="dataAbertura" 
                    formControlName="dataAbertura">
                </bn-datepicker>
            </div>

            <div class="bn-form-group col-md-4">
                <label class="form-label">Data de fechamento:</label>
                <bn-datepicker 
                    name="dataFechamento" 
                    idInput="dataFechamento" 
                    formControlName="dataFechamento">
                </bn-datepicker>
            </div>

            <div class="bn-form-group col-md-4">
                <label class="form-label">Tipo de Janela:</label>
                <select id="tipoJanela" class="form-select" formControlName="tipoJanela">
                    <option [ngValue]=null>Todos</option>
                    <option *ngFor="let tipoJanela of tiposJanela" 
                            [selected]="valoresPesquisaForm && valoresPesquisaForm.tipoJanela == tiposJanela.codigo" 
                            [ngValue]="tipoJanela.codigo">{{ tipoJanela.label }}</option>
                </select>
            </div>
        </div>
    </form>
</div>

<app-janelas-atualizacao-informacoes-listagem *ngIf="pesquisado"
    [janelas]="janelas"
    [atributosPaginacao]="atributosPaginacaoComponenteListagem"
    [podeIncluirNovaJanela]="podeIncluirNovaJanela"
    (aoMudarPagina)="mudancaPagina($event)">
</app-janelas-atualizacao-informacoes-listagem>
